export default {"tab":"l34Nf","list":"meWuZ","item":"oyik9","link":"RbXwf","active":"uqpda"};